import HeroButton from "@components/HeroButton";
import Image from "next/image";
import { FC } from "react";

interface TwoButtonHeaderProps {
    pageTitle?: string;
    mainTitle?: string;
    description?: string;
    buttonText?: string;
    imageUrl?: string;
}

const TwoButtonHeader: FC<TwoButtonHeaderProps> = ({ pageTitle, mainTitle, description, imageUrl = "" }) => {
    return (
        <header className="max-w-6xl mx-auto px-4 lg:px-0 pt-4  bg-white ">
            <div className="flex flex-col lg:flex-row justify-center md:justify-between lg:py-20 pt-0">
                <div className="lg:w-6/12 w-full flex flex-col pt-10">
                    <div
                        className="text-green-700 bg-green-100 wati-top-green justify-center items-center lg:text-base font-bold flex flex-nowrap w-fit m-auto md:m-0"
                        style={{ padding: "1px 12px", borderRadius: "50px", border: "0.5px solid rgb(9, 146, 80)" }}
                    >
                        <h1 className="lg:text-base text-xs pr-1">{pageTitle}</h1>
                        <span className="wa-control-img">
                            <Image
                                alt="white-border"
                                height={24}
                                loading="lazy"
                                width={24}
                                src="https://assets.gallabox.com/gb-home/new-zapier/wa-w-whiteborder.svg"
                                className="ml-2"
                            />
                        </span>
                    </div>
                    <h2 className="flex flex-col lg:justify-start justify-center text-gray-600 lg:pt-4">
                        <span className="lg:text-4xl lg:font-bold text-3xl text-gray-600">{mainTitle}</span>
                    </h2>
                    <p className="lg:py-6 py-4 lg:text-l font-normal text-center lg:text-left lg:text-gray-700 text-gray-600">{description}</p>
                    <div className="flex flex-col pt-4 lg:pt-0 md:flex-row gap-6 justify-center md:justify-start mx-auto md:mx-0">
                        <HeroButton bookDemoButtonClass="py-4" />

                        <button
                            onClick={() => {
                                const pricingTable = document.getElementById("scroll-here");
                                if (pricingTable) {
                                    pricingTable.scrollIntoView({ behavior: "smooth" });
                                }
                            }}
                            className="bg-green-500 text-white font-bold px-4 lg:mt-6 py-4 rounded-lg hover:bg-green-600 transition duration-300 border-transparent"
                        >
                            View Offer
                        </button>
                    </div>

                    <div className="flex gap-4 px-2 lg:px-0 mt-6">
                        {["No setup fee", "No credit card required"].map((each) => {
                            return (
                                <div className="flex items-center gap-1 md:gap-2" key={each}>
                                    <img src="https://assets.gallabox.com/gb-home/content-with-image/grey-tick-circle.svg" alt="Gray checkmark" className="opacity-50" />
                                    <p className="head-points text-gray-400">{each}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="lg:w-1/2 w-full">
                    <Image width={520} height={400} loading="lazy" src={imageUrl} alt="odoo-header-image" />
                </div>
            </div>
        </header>
    );
};

export default TwoButtonHeader;
